<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 10:21:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-22 14:12:16
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-col cols="12" class='d-flex'>
          <mrc_ess_switch :true-value="1" v-if="$store.state.uuid" :false-value="0" v-model.number="list.is_used"
            :readonly="disabled" style="margin-right:35px" :true-text="$t('label_To_enable_the')"
            :false-text="$t('label_disable')">
          </mrc_ess_switch>
        </v-col>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText :label="$t('label_Template_name') + '*'" :isNational="judegNational('template_name')"
              :readonly="disabled" :error-messages="$errors('list', 'template_name', requiredRule.concat(nocharacter))"
              v-model="list.template_name">
            </mrc_ess_multiText>
          </v-col>

          <v-col cols="12" v-if="$store.state.userData.userType == 4" sm="6">
            <mrc_ess_autoComplete :label="$t('label_associated_customers') + '*'" :readonly="disabled" clientView
              @changeStaff='changeClientUuid' :error-messages="$errors('list', 'client_uuid', requiredRule)"
              v-model="list.client_uuid" prompt_name="administrator_client">
            </mrc_ess_autoComplete>
          </v-col>

          <v-col cols="12" sm="6">

            <mrc_ess_multiText :label="$t('label_001-001_001-018-006_template_classification') + '*'"
              v-if="$store.state.userData.userType != 4"
              :error-messages="$errors('list', 'template_code', requiredRule.concat(nocharacter))"
              :isNational="judegNational('template_code')" :readonly="disabled" v-model="list.template_code">
            </mrc_ess_multiText>

            <!-- <mrc_ess_dictName v-else
                              v-model="list.template_code"
                              :disabled="disabled"
                              :label="$t('label_001-001_001-018-006_template_classification')+'*'"
                              :error-messages="$errors('list', 'template_code', requiredRule.concat(nocharacter))"
                              :rules="false"
                              dict_name="MailTempldateCode"></mrc_ess_dictName> -->
            <mrc_ess_autoComplete v-else v-model="list.template_code" :readonly="disabled"
              :label="$t('label_001-001_001-018-006_template_classification') + '*'"
              :error-messages="$errors('list', 'template_code', requiredRule.concat(nocharacter))"
              :prompt_name="client_mail_template_code">
            </mrc_ess_autoComplete>
          </v-col>

          <v-col cols="12" sm="6">
            <mrc_ess_autoComplete :label="$t('label_The_module')" :readonly="disabled" moduleView @changeStaff="getData"
              v-model="list.module_uuid" :prompt_name="module_reference">
            </mrc_ess_autoComplete>
            <!-- BJ 2023-08-01 取消必填 -->
            <!-- :error-messages="$errors('list', 'module_uuid', requiredRule)" -->
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_autoComplete :label="$t('label_function')" :readonly="disabled" functionView
              v-model="list.function_uuid" :prompt_name="function_reference">
            </mrc_ess_autoComplete>
            <!-- BJ 2023-08-01 取消必填 -->
            <!-- :error-messages="$errors('list', 'function_uuid', requiredRule)" -->
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_describe') + '*'" :isNational="judegNational('template_remark')"
              :readonly="disabled" :error-messages="$errors('list', 'template_remark', requiredRule.concat(nocharacter))"
              v-model="list.template_remark">
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <template v-if="$store.state.uuid">
        <mrc_ess_submitBtn @cancel="cancel" :loading="loading" @success="success" v-if="!disabled"></mrc_ess_submitBtn>
      </template>
      <template v-else>
        <mrc_ess_submitBtn @cancel="addcancel" @success="addsuccess" :successText="$t('label_The_next_step')"
          v-if="!disabled"></mrc_ess_submitBtn>
      </template>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getemailtemplatelist,
  getdetailemailtemplate,
  updateemailtemplate,
} from '@/service/api/emailtemplate'
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      skeletonloading: true,
      list: {
        is_used: 1,
      },
      loading: false,
    }
  },
  computed: {
    client_mail_template_code() {
      return { prompt_name: 'client_mail_template_code', uuid: this.$store.state.uuid || '', client_uuid: this.list.client_uuid }
    },
    function_reference() {
      return { prompt_name: 'function_reference', uuid: this.list.module_uuid }
    },
    module_reference() {
      return {
        prompt_name: 'module_reference',
        uuid: this.$store.state.currentCompany,
      }
    },
  },
  created() { },
  watch: {
  },
  async mounted() {
    this.national('mrbase_sys_mail_template')
    if (this.$store.state.uuid) {
      await this.getdetail()
    }
    else {
    }
  },

  methods: {
    changeClientUuid() {
      this.list.template_code = ''
    },
    getData(val) {
      this.$set(this.list, 'function_uuid', '')
    },
    async getdetail() {
      this.skeletonloading = true
      const res = await getdetailemailtemplate({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        // this.$store.commit('set_subPage_name', res.data.template_name)
        this.list = res.data
        this.skeletonloading = false
      }
    },
    async cancel() {
      this.getdetail()
      this.$emit('changeReadonly')
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'emailtemplate',
      //     })
      //   })
      //   .catch((err) => { })
    },
    async success() {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      this.loading = true
      await updateemailtemplate(this.$deletefield(null, this.list)).then(
        (res) => {
          if (res.code == 200) {
            this.getdetail()
            this.$emit('changeReadonly')
            this.$emit('changeFunctionUuid')
            this.$Message({
              text: this.$t('message_The_operation_was_successful'),
            })
          }
        }
      )
      this.loading = false
    },
    addcancel() {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      })
        .then((res) => {
          this.$router.push({
            name: 'emailtemplate',
          })
        })
        .catch((err) => { })
    },
    addsuccess() {
      // console.log(this.list);
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      this.$emit('changee1', 2, this.list)
    },
  },
  validations: {
    list: {
      template_name: {
        required, nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      template_code: {
        required, nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        }
      },
      client_uuid: {
        required() {
          return this.$store.state.userData.userType == 4 ? required : true
        },
        // systemRequired (value) {
        //   if (this.$store.state.userData.userType == 4) {
        //     return value
        //   }
        //   else {

        //   }
        // }
      },
      // module_uuid: {
      //   required,
      // },
      // function_uuid: {
      //   required,
      // },
      // isshow: {

      // },
      template_remark: {
        required, nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
    },
  },
}
</script>

<style scoped></style>
